// Italiano
export default {
    // Research papers page (/research)
    "nav.globe": "Globo",
    "nav.research": "Ricerca",
    "rs.title": "Studi e ricerche",
    "rs.sub": "Nuove ricerche di finanza quantitativa e delle banche centrali da arXiv, Fed, BCE, BRI e NBER. Gratis da leggere alla fonte; aggiornato ogni 6 ore.",
    "rs.search": "Cerca titoli, autori, riassunti…",
    "rs.allTopics": "Tutti i temi",
    "rs.allSources": "Tutte le fonti",
    "rs.allCountries": "Tutti i paesi",
    "rs.count": "{n} studi",
    "rs.none": "Nessuno studio corrisponde ai filtri.",
    "rs.clear": "Azzera filtri",
    "rs.download": "Scarica il PDF da {source}",
    "rs.read": "Leggi su {source}",
    "rs.onGlobe": "Apri {country} sul globo",
    "rs.note": "Titoli, autori e riassunti rimandano agli editori originali; i PDF si aprono sui loro siti. Ricerca, non consulenza finanziaria.",
    "rs.global": "Globale",
    "rs.loadMore": "Carica altri",
    "rs.details": "Dettagli",
    "rs.copy": "Copia link",
    "rs.copied": "Link copiato",
    "rs.published": "Pubblicato",
    "panel.research": "Ricerche su {country}",
    "panel.researchAll": "Tutte le ricerche →",
    "rt.trading": "Trading e struttura dei mercati",
    "rt.portfolio": "Portafogli e investimenti",
    "rt.risk": "Rischio",
    "rt.pricing": "Derivati e modelli di prezzo",
    "rt.forecasting": "IA e previsioni",
    "rt.crypto": "Cripto e asset digitali",
    "rt.macro": "Economia e banche centrali",
    "topic.r-trading": "La ricerca sul trading studia come si formano i prezzi e come vengono eseguiti gli ordini: strategie, book di negoziazione, liquidità e costi.",
    "topic.r-portfolio": "La ricerca sui portafogli studia come combinare gli investimenti: quali fattori spiegano i rendimenti, come bilanciare rischio e rendimento, come investire per la pensione.",
    "topic.r-risk": "La ricerca sul rischio misura cosa può andare storto: grandi perdite, crolli di mercato, crisi bancarie e come proteggersi.",
    "topic.r-pricing": "La ricerca sui prezzi costruisce la matematica che valuta opzioni e altri contratti, e i modelli della volatilità.",
    "topic.r-forecasting": "La ricerca su IA e previsioni verifica se machine learning, modelli linguistici e statistica possono prevedere prezzi o economia, e con quale affidabilità.",
    "topic.r-crypto": "La ricerca sulle cripto studia criptovalute, stablecoin, blockchain e asset tokenizzati: come vengono scambiati e quali rischi comportano.",
    "topic.r-macro": "La ricerca economica studia crescita, inflazione, tassi d’interesse e politica delle banche centrali, che muovono i mercati per mesi e anni.",
    'lang.label': 'Lingua',
    'nav.reports': 'Report',
    'nav.stocks': 'Monitoraggio azioni',
    loading: 'Caricamento delle notizie dal mondo…',
    'err.title': 'Impossibile caricare',
    'err.msg': 'Si è verificato un errore durante il caricamento dell’app.',
    'err.retry': 'Riprova',
    atlas: 'Atlante',
    'search.label': 'Cerca paesi',
    'search.ph': 'Cerca paesi o codici…',
    'filter.region': 'Regione',
    'filter.allRegions': 'Tutte le regioni',
    'filter.window': 'Periodo',
    'filter.topic': 'Argomento',
    'filter.all': 'Tutto',
    'stage.title': 'I mercati, adesso',
    legend: 'Legenda',
    lastUpdate: 'Ultimo aggiornamento',
    pauseRotation: 'Ferma rotazione',
    resumeRotation: 'Riprendi rotazione',
    hint: 'Trascina per ruotare · clicca un punto per aprire un paese',
    'panel.latest': 'Ultime notizie',
    'quiet.none': 'Nessuna notizia in questo periodo.',
    'quiet.sub': 'Prova un periodo più ampio (7G o 30G), oppure segui questo paese per tenerlo nella tua lista.',
    'footer.about': 'Chi siamo',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Termini',
    follow: '☆ Segui',
    following: '★ Seguito',
    followingGroup: 'Seguiti',
    explain: 'Spiegamelo',
    hideExplain: 'Nascondi spiegazione',
    share: 'Condividi',
    whyMatter: 'Perché può contare',
    disclaimer: 'Contesto educativo, non consulenza finanziaria.',
    readAt: 'Leggi l’articolo completo su {source}',
    translate: 'Traduci',
    showing: 'Mostrate {n} di {total}',
    loadMore: 'Carica altre {n}',
    loadingShort: 'Caricamento…',
    'story.one': '{n} notizia',
    'story.other': '{n} notizie',
    noStories: 'nessuna notizia',
    justNow: 'Adesso',
    minAgo: '{n} min fa',
    hAgo: '{n} h fa',
    dAgo: '{n} g fa',
    'range.24h': 'ultime 24 ore',
    'range.7d': 'ultimi 7 giorni',
    'range.30d': 'ultimi 30 giorni',
    'range.all': 'tutto',
    'cont.Africa': 'Africa',
    'cont.Asia': 'Asia',
    'cont.Europe': 'Europa',
    'cont.North America': 'America del Nord',
    'cont.Oceania': 'Oceania',
    'cont.South America': 'America del Sud',
    'cat.markets': 'Mercati',
    'cat.economy': 'Economia',
    'cat.central-banks': 'Banche centrali',
    'cat.policy': 'Politica e geopolitica',
    'cat.companies': 'Aziende',
    today: 'Oggi',
    'today.top': 'Il mondo in 60 secondi',
    'today.banks': 'Decisioni delle banche centrali',
    'today.mine': 'I tuoi paesi',
    'today.emptyTop': 'Ancora nessuna notizia importante oggi. Torna più tardi.',
    'today.emptyMine': 'Premi ☆ Segui su un paese per fissarlo qui.',
    'today.note': 'I titoli rimandano agli editori originali. Solo contesto educativo, non consulenza finanziaria.',
    'today.open': 'Apri {country}',
    close: 'Chiudi',
    'cal.timeVaries': 'orario variabile',
    'cal.yourTime': '{time} nel tuo orario',
    'cal.in': 'tra {t}',
    'cal.today': 'Decisione annunciata oggi',
    'bank.fed': 'Federal Reserve',
    'bank.ecb': 'Banca Centrale Europea',
    'bank.boe': 'Banca d’Inghilterra',
    'bank.boj': 'Banca del Giappone',
    'auth.signIn': 'Accedi',
    'auth.account': 'Account',
    'auth.btnTitle': 'Account gratuito: salva i tuoi paesi su tutti i dispositivi',
    'auth.freeTitle': 'Account gratuito',
    'auth.freeSub': "Salva i paesi che segui su tutti i tuoi dispositivi. Nessuna password: ti inviamo un codice monouso via email.",
    'auth.emailBtn': "Inviami un codice di accesso",
    'auth.sending': 'Invio in corso…',
    'auth.check': 'Controlla la tua casella di posta: il link scade tra 20 minuti.',
    "auth.codeTitle": "Controlla la tua email",
    "auth.codeSent": "Abbiamo inviato un codice di 6 cifre a {email}. Inseriscilo qui:",
    "auth.codeLabel": "Codice di accesso",
    "auth.codeBtn": "Accedi",
    "auth.junk": "Non la vedi? Può volerci un minuto. Controlla anche la cartella Spam o Posta indesiderata e segnala l'email come \"Non spam\", così le prossime arriveranno nella posta in arrivo.",
    "auth.otherEmail": "Usa un'altra email",
    'auth.dev': 'Modalità sviluppo (nessun server email):',
    'auth.devLink': 'clicca qui per accedere',
    'auth.fine': 'Usiamo la tua email solo per farti accedere. Leggi l’{link}.',
    'auth.privacy': 'informativa sulla privacy',
    'auth.yourAccount': 'Il tuo account',
    'auth.signedInAs': 'Accesso effettuato come {email}',
    'auth.followCount': 'Segui {n} paesi, sincronizzati su tutti i tuoi dispositivi.',
    'auth.signOut': 'Esci',
    'auth.delete': 'Elimina il mio account',
    "auth.confirmDelete": "Eliminare il tuo account? Verranno cancellati la tua email e i paesi salvati, e non riceverai più email da NewsNetWide. L’operazione non si può annullare.",
    'auth.deletedTitle': 'Account eliminato',
    "auth.deletedSub": "La tua email, i paesi salvati e l’iscrizione alle email sono stati cancellati.",
    'auth.inTitle': 'Accesso effettuato',
    'auth.inSub': 'Benvenuto/a, {email}. I paesi che segui sono ora salvati nel tuo account.',
    'auth.expired': 'Il link è scaduto. Richiedine uno nuovo qui sotto.',
    'auth.used': 'Il link è già stato usato o non è valido. Richiedine uno nuovo qui sotto.',
    'share.source': 'Fonte',
    'share.tagline': 'Tutte le notizie che muovono i mercati, su un solo globo',
    'share.notAdvice': 'Notizie, non consulenza finanziaria',
    'mc.open': 'Aperto',
    'mc.pre': 'Pre-apertura',
    'mc.post': 'After-hours',
    'mc.night': 'Sessione notturna',
    'mc.break': 'Pausa di mezzogiorno',
    'mc.closed': 'Chiuso',
    'mc.holiday': 'Festivo',
    'mc.closesIn': 'Chiude tra {t}',
    'mc.opensIn': 'Apre tra {t}',
    'mc.endsIn': 'Termina tra {t}',
    'mc.reopensIn': 'Riapre tra {t}',
    'mc.preIn': 'Pre-apertura tra {t}',
    'mc.afterIn': 'After-hours tra {t}',
    'mc.nightIn': 'Sessione notturna tra {t}',
    'mc.openCount': '{n} aperti',
    'mc.all': 'Tutti i mercati',
    "mc.title": "Orari dei mercati",
    "side.countries": "Paesi",
    "side.menu": "Menu",
    "tools.pricingSub": "I piani e cosa include ciascuno",
    'mc.noHolidays': 'festivi non inclusi',
    'mc.local': 'ora locale',
    'mc.note': 'Orari regolari di ogni borsa nella sua ora locale. I festivi sono inclusi per i mercati di Stati Uniti, Regno Unito, Germania ed Euronext Parigi (2026–27); altre borse possono chiudere nei festivi locali. Le sessioni notturne riguardano i future sugli indici (Tokyo OSE, Hong Kong HKFE).',
    'topic.markets': 'Le notizie sui mercati riguardano i prezzi di azioni, obbligazioni, valute e materie prime: cosa comprano e vendono gli investitori, e perché.',
    'topic.economy': 'Le notizie economiche (crescita, lavoro, inflazione, commercio) influenzano gli utili delle aziende e le decisioni delle banche centrali nei mesi successivi.',
    'topic.central-banks': 'Le banche centrali fissano i tassi di interesse, il prezzo del denaro, che incide su prestiti, risparmi, valute e prezzi degli investimenti.',
    'topic.policy': 'Le scelte dei governi (tasse, bilanci, regole commerciali, sanzioni, elezioni, conflitti) possono cambiare costi e rischi di interi settori.',
    'topic.companies': 'Le notizie sulle aziende (risultati, operazioni, licenziamenti) possono muovere le loro azioni e a volte l’intero settore.',
    'snap.title': 'Istantanea per l’investitore',
    'snap.source': 'Ultimi dati ufficiali annuali · World Bank Open Data. Contesto, non previsioni né consulenza.',
    'snap.gdp_growth': 'Crescita del PIL',
    'snap.inflation': 'Inflazione',
    'snap.unemployment': 'Disoccupazione',
    'snap.gdp_per_capita': 'PIL per persona',
    'snap.current_account': 'Partite correnti',
    'snap.exports': 'Esportazioni',
    'snap.ofGdp': 'del PIL',
    'snap.gdp.shrink': 'L’economia si sta contraendo.',
    'snap.gdp.slow': 'Crescita lenta.',
    'snap.gdp.moderate': 'Crescita moderata.',
    'snap.gdp.fast': 'Crescita rapida.',
    'snap.inf.deflation': 'I prezzi scendono (deflazione).',
    'snap.inf.target': 'Vicina al ~2% a cui mira la maggior parte delle banche centrali.',
    'snap.inf.above': 'Sopra gli obiettivi abituali delle banche centrali.',
    'snap.inf.high': 'Inflazione alta: il denaro perde valore rapidamente.',
    'snap.unemp.low': 'Bassa: il mercato del lavoro è teso.',
    'snap.unemp.moderate': 'Moderata.',
    'snap.unemp.high': 'Alta: molte persone non trovano lavoro.',
    'snap.gdppc.note': 'Produzione media per persona: una misura approssimativa di quanto è ricco un paese.',
    'snap.ca.surplus': 'Avanzo: guadagna dall’estero più di quanto spende.',
    'snap.ca.deficit': 'Disavanzo: spende all’estero più di quanto guadagna e dipende da capitali stranieri.',
    'snap.exp.very': 'Molto dipendente dal commercio: sensibile ai dazi e alla domanda mondiale.',
    'snap.exp.open': 'Un’economia aperta agli scambi.',
    'snap.exp.domestic': 'Trainata soprattutto dal mercato interno.',
    "auth.since": "Iscritto dal {date}",
    "auth.followed": "Paesi che segui",
    "auth.noneFollowed": "Ancora nessuno. Premi ☆ Segui su un paese per aggiungerlo qui.",
    "auth.unfollow": "Smetti di seguire {country}",
    "auth.email": "Email",
    "auth.prefUpdates": "Aggiornamenti NewsNetWide",
    "auth.prefUpdatesSub": "Nuove funzioni e notizie sul sito",
    "auth.prefNews": "Newsletter",
    "auth.prefNewsSub": "Il meglio delle notizie sui mercati",
    "auth.saved": "Salvato.",
    "auth.prefsError": "Le impostazioni email non sono disponibili al momento.",
    "auth.plan": "Piano",
    "auth.seePlans": "Vedi i piani",
    "auth.manage": "Gestisci abbonamento",
    "auth.trialUntil": "prova gratuita fino al {date}",
    "auth.renews": "si rinnova il {date}",
    "auth.endsOn": "termina il {date}",
    "auth.briefing": "Briefing del mattino",
    "auth.briefingOn": "Inviami un briefing ogni mattina",
    "auth.briefingSub": "Le notizie principali dei paesi che segui e le date chiave in arrivo. Puoi disattivarlo quando vuoi.",
    "auth.briefingNone": "Non segui ancora nessun paese, quindi inizia con le notizie principali dal mondo.",
    "auth.briefingCount": "Paesi nel tuo briefing: {n}",
    "auth.briefingAt": "Invialo alle",
    "auth.briefingTz": "ora locale ({tz})",
    "auth.briefingPreview": "Vedi l'esempio di oggi ↗",
    "panel.page": "Pagina del paese ↗",
    "footer.countries": "Paesi",
    glossary: {
        'central-bank': ['Banca centrale', 'L’istituzione che fissa i tassi di interesse di un paese e gestisce la quantità di moneta.', 'Le sue decisioni cambiano il costo del denaro per tutti e muovono obbligazioni, azioni e valuta.'],
        fed: ['Federal Reserve (Fed)', 'La banca centrale degli Stati Uniti; il suo comitato (FOMC) fissa i tassi americani.', 'I tassi USA influenzano il costo del credito e i flussi di investimento in tutto il mondo.'],
        ecb: ['Banca Centrale Europea (BCE)', 'La banca centrale dei 20 paesi che usano l’euro.', 'Le sue decisioni incidono su mutui, prestiti alle imprese e valore dell’euro.'],
        boe: ['Banca d’Inghilterra', 'La banca centrale del Regno Unito; il suo Comitato di politica monetaria fissa i tassi britannici.', 'Le sue decisioni muovono la sterlina, i titoli di Stato britannici e il costo del credito nel Regno Unito.'],
        boj: ['Banca del Giappone', 'La banca centrale del Giappone.', 'Le variazioni dei suoi tassi, molto bassi, possono muovere lo yen e i flussi di investimento mondiali.'],
        'interest-rate': ['Tasso di interesse', 'Il prezzo per prendere denaro in prestito, di solito una percentuale annua.', 'Tassi più alti rendono i prestiti più cari e di solito frenano la spesa; tassi più bassi fanno il contrario.'],
        'rate-cut': ['Taglio dei tassi', 'Una banca centrale abbassa il suo tasso di interesse.', 'Un credito più economico può sostenere spesa e utili, ma può anche segnalare preoccupazione per l’economia.'],
        'rate-hike': ['Rialzo dei tassi', 'Una banca centrale alza il suo tasso di interesse.', 'Di solito serve a frenare l’inflazione e rende il credito più caro per famiglie e imprese.'],
        'basis-points': ['Punti base', 'Un punto base è lo 0,01%; 25 punti base sono un quarto di punto percentuale.', 'Le variazioni dei tassi si esprimono in punti base, quindi indicano quanto è grande il movimento.'],
        qe: ['Quantitative easing (QE)', 'Una banca centrale compra (QE) o riduce (QT) grandi quantità di obbligazioni per influenzare i tassi a lungo termine.', 'Cambia la quantità di denaro che circola nei mercati finanziari.'],
        inflation: ['Inflazione', 'Il ritmo a cui salgono i prezzi; di solito si misura con l’indice dei prezzi al consumo (IPC).', 'Un’inflazione alta può spingere le banche centrali a tenere i tassi alti e riduce il potere d’acquisto.'],
        gdp: ['PIL', 'Prodotto interno lordo: il valore totale di beni e servizi prodotti da un’economia.', 'È la misura più ampia per capire se un’economia cresce o si contrae.'],
        recession: ['Recessione', 'Un calo forte e diffuso dell’attività economica, spesso due trimestri di PIL in discesa.', 'Le recessioni di solito portano meno utili per le aziende e più disoccupazione.'],
        unemployment: ['Disoccupazione', 'La quota di persone che vogliono lavorare ma non hanno un impiego; i dati sui posti di lavoro contano quelli creati.', 'I dati sul lavoro mostrano la forza dell’economia e influenzano le banche centrali.'],
        pmi: ['PMI', 'Indice dei direttori degli acquisti: sondaggio mensile sull’attività delle imprese. Sopra 50 indica espansione.', 'È uno dei primi segnali della direzione dell’economia.'],
        'trade-deficit': ['Bilancia commerciale', 'La differenza tra ciò che un paese esporta e ciò che importa.', 'Grandi squilibri possono influire sulla valuta e provocare dispute commerciali.'],
        tariff: ['Dazio', 'Una tassa sulle merci importate.', 'I dazi aumentano i costi per chi importa e per i consumatori, e possono ridurre vendite e utili degli esportatori.'],
        sanctions: ['Sanzioni', 'Restrizioni che un paese impone al commercio o alla finanza con un altro.', 'Possono chiudere mercati, alterare le catene di fornitura e muovere i prezzi delle materie prime.'],
        budget: ['Bilancio e politica fiscale', 'Come un governo raccoglie, spende e prende in prestito denaro.', 'Grandi deficit o stimoli possono influire su crescita, obbligazioni e valuta.'],
        'bond-yield': ['Rendimento delle obbligazioni', 'Quanto guadagna un investitore con un’obbligazione; quando il prezzo scende, il rendimento sale.', 'I rendimenti dei titoli di Stato fissano il costo di base del credito in tutta l’economia.'],
        index: ['Indice di borsa', 'Un paniere di azioni che segue un mercato, come l’S&P 500 (500 grandi aziende americane).', 'Gli indici riassumono in un solo numero l’andamento di un intero mercato.'],
        'sell-off': ['Ondata di vendite', 'Un periodo in cui molti investitori vendono insieme e i prezzi scendono rapidamente.', 'Spesso riflette paura o cattive notizie; non dice nulla di certo su cosa succederà dopo.'],
        volatility: ['Volatilità', 'Quanto e quanto velocemente i prezzi salgono e scendono.', 'Più volatilità significa più incertezza e oscillazioni maggiori, in entrambe le direzioni.'],
        currency: ['Tasso di cambio', 'Il prezzo di una valuta espresso in un’altra.', 'I movimenti delle valute cambiano il costo delle importazioni, dei viaggi e il valore degli investimenti esteri.'],
        oil: ['Prezzo del petrolio', 'Il prezzo di mercato del greggio; Brent e WTI sono i riferimenti principali. L’OPEC riunisce paesi produttori.', 'Il petrolio incide sui costi di carburante, trasporti e produzione, e quindi sull’inflazione.'],
        gold: ['Oro', 'L’oro scambiato come materia prima.', 'Molti investitori lo comprano nei periodi incerti, perciò il suo prezzo riflette il nervosismo dei mercati.'],
        crypto: ['Criptovaluta', 'Attività digitali come il bitcoin, scambiate 24 ore su 24 senza banca centrale.', 'I prezzi sono molto volatili e reagiscono alle regole e alla propensione al rischio.'],
        etf: ['ETF', 'Un fondo quotato in borsa come un’azione, che di solito replica un indice.', 'Gli ETF sono un modo comune ed economico per investire in un intero mercato.'],
        earnings: ['Utili', 'Il profitto che un’azienda dichiara in un periodo, spesso per azione (EPS).', 'Utili migliori o peggiori delle attese degli analisti spesso muovono il prezzo dell’azione.'],
        revenue: ['Ricavi', 'Tutto il denaro che un’azienda incassa vendendo prodotti o servizi, prima dei costi.', 'La crescita dei ricavi mostra se la domanda per i suoi prodotti aumenta.'],
        guidance: ['Previsioni aziendali', 'Ciò che l’azienda stessa prevede per i risultati futuri.', 'Le modifiche alle previsioni spesso contano quanto i risultati passati.'],
        ipo: ['Quotazione in borsa (IPO)', 'Quando un’azienda vende azioni per la prima volta in una borsa.', 'Permette al pubblico di investire e mostra l’interesse per le nuove quotazioni.'],
        merger: ['Fusioni e acquisizioni', 'Un’azienda si unisce a un’altra o la acquista.', 'Le operazioni possono cambiare la concorrenza e spesso muovono le azioni di entrambe le aziende.'],
        buyback: ['Riacquisto di azioni proprie', 'Un’azienda ricompra le proprie azioni sul mercato.', 'Restituisce denaro agli azionisti e riduce il numero di azioni; non garantisce valore.'],
        dividend: ['Dividendo', 'Una parte dell’utile distribuita agli azionisti.', 'Le variazioni del dividendo indicano la fiducia dell’azienda nella propria liquidità.'],
        layoffs: ['Licenziamenti', 'Un’azienda riduce il numero di dipendenti.', 'Può segnalare pressione sui costi o una ristrutturazione, e incide sul mercato del lavoro.'],
        bankruptcy: ['Fallimento', 'Una procedura legale quando un’azienda non riesce a pagare i propri debiti.', 'Gli azionisti di solito perdono quasi tutto; i creditori possono recuperarne una parte.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Calendario",
    "nav.tools": "Strumenti",
    "nav.pricing": "Prezzi",
    "tools.soon": "PRESTO",
    "tools.briefing": "Briefing del mattino",
    "tools.briefingSub": "Le notizie dei tuoi paesi via email, ogni mattina",
    "tools.calculators": "Calcolatori finanziari",
    "tools.calculatorsSub": "Interesse composto, obiettivi di risparmio, commissioni",
    "tools.holdings": "Monitor dei titoli",
    "tools.holdingsSub": "Le notizie sulle aziende che possiedi",
    "tools.papers": "Analisi degli articoli",
    "tools.papersSub": "Qualsiasi paper di ricerca, spiegato in parole semplici",
    "tools.montecarlo": "Simulatore Monte Carlo",
    "tools.montecarloSub": "Risparmio, trading e strategie con opzioni, con PDF",
    "cal.title": "Calendario economico",
    "cal.sub": "Decisioni delle banche centrali, dati economici chiave, chiusure dei mercati e festività, da fonti ufficiali, nel tuo fuso orario.",
    "cal.todayLabel": "Oggi",
    "cal.tomorrow": "Domani",
    "cal.yesterday": "Ieri",
    "cal.allDay": "Tutto il giorno",
    "cal.now": "ora",
    "cal.inDH": "tra {d} g {h} h",
    "cal.inHM": "tra {h} h {m} min",
    "cal.inM": "tra {m} min",
    "cal.decision": "{bank}: decisione sui tassi",
    "cal.closed": "{exchange} chiusa",
    "cal.early": "{exchange} chiude in anticipo",
    "cal.estimated": "data stimata",
    "cal.yourTz": "Orari nel tuo fuso orario ({tz})",
    "cal.type.public_holiday": "Festività",
    "cal.allCountries": "Tutti i paesi",
    "cal.yourCountries": "I tuoi paesi",
    "cal.noFollows": "Segui dei paesi sul globo per filtrarli qui.",
    "cal.addToCal": "Aggiungi al calendario",
    "cal.subscribe": "Iscriviti",
    "cal.subscribeHint": "Copia questo link in Google Calendar, Calendario Apple o Outlook («aggiungi da URL»). Si aggiorna da solo.",
    "cal.copied": "Link copiato",
    "cal.source": "Fonte ufficiale",
    "cal.relatedNews": "Notizie su {country}",
    "cal.period": "Periodo: {period}",
    "cal.none": "Nessun evento per questi filtri.",
    "cal.error": "Il calendario non è disponibile al momento. Riprova tra poco.",
    "cal.comingUp": "In arrivo",
    "cal.fullCalendar": "Calendario completo",
    "cal.euroArea": "Area euro",
    "cal.note": "Date e orari provengono da ogni banca centrale, borsa e istituto di statistica (link su ogni evento). Festività: libreria open source «holidays» (MIT). Non mostriamo mai previsioni. Notizie e contesto, non consulenza finanziaria.",
    "cal.series.us_cpi": "Prezzi al consumo USA (CPI)",
    "cal.series.us_jobs": "Rapporto sul lavoro USA",
    "cal.series.us_ppi": "Prezzi alla produzione USA (PPI)",
    "cal.series.us_jolts": "Posti vacanti USA (JOLTS)",
    "cal.series.us_eci": "Indice del costo del lavoro USA",
    "cal.series.us_gdp": "PIL USA",
    "cal.series.us_pce": "Redditi e spesa USA (PCE)",
    "cal.series.us_trade": "Bilancia commerciale USA",
    "cal.series.ea_hicp_flash": "Inflazione area euro (stima flash)",
    "cal.series.ea_hicp": "Inflazione area euro (definitiva)",
    "cal.series.ea_gdp_flash": "PIL area euro (stima flash preliminare)",
    "cal.series.ea_gdp": "PIL e occupazione area euro",
    "cal.series.ea_unemployment": "Disoccupazione area euro",
    "cal.series.ea_retail": "Vendite al dettaglio area euro",
    "cal.series.uk_cpi": "Prezzi al consumo Regno Unito (CPI)",
    "cal.series.uk_gdp_q": "PIL Regno Unito (trimestrale)",
    "cal.series.uk_gdp_m": "PIL Regno Unito (mensile)",
    "cal.series.uk_jobs": "Mercato del lavoro Regno Unito",
    "cal.series.uk_retail": "Vendite al dettaglio Regno Unito",
    "cal.series.au_cpi": "Prezzi al consumo Australia (CPI)",
    "cal.series.au_jobs": "Forza lavoro Australia",
    "cal.series.au_gdp": "PIL Australia",
    "bank.snb": "Banca nazionale svizzera",
    "bank.boc": "Banca del Canada",
    "bank.rba": "Reserve Bank of Australia",
    "bank.rbnz": "Reserve Bank of New Zealand",
    "bank.riksbank": "Riksbank (Svezia)",
    "bank.norges": "Norges Bank (Norvegia)",
    "bank.rbi": "Reserve Bank of India",
    "cal.promise1": "Solo fonti ufficiali",
    "cal.promise2": "Nessuna previsione, solo date e risultati",
    "cal.promise3": "Feed calendario gratuito",
    "cal.yourTimeShort": "ora tua",
    "cal.unitD": "giorni",
    "cal.unitH": "h",
    "cal.unitM": "min",
    "cal.approxNote": "Orario indicativo: la banca non lo fissa in anticipo",
    "cal.then": "Poi:",
    "cal.nextDecisions": "Prossime decisioni sui tassi",
    "cal.bankCalendars": "Calendari ufficiali delle banche · conto alla rovescia all'annuncio",
    "cal.marketsWeek": "Borse questa settimana",
    "cal.mktAside": "Chiusure questa settimana: {n} · orari in {tz}",
    "cal.mktNote": "Solo la seduta principale. Le chiusure vengono dal calendario ufficiale di ogni borsa.",
    "cal.exchange": "Borsa",
    "cal.rightNow": "Adesso",
    "cal.mkt.open": "Aperta",
    "cal.mkt.pre": "Non ancora aperta",
    "cal.mkt.break": "Pausa pranzo",
    "cal.mkt.closedToday": "Chiusa oggi",
    "cal.mkt.closed": "Chiusa",
    "cal.mkt.closesAt": "chiude alle {time} (ora tua)",
    "cal.mkt.opensAt": "apre alle {time} (ora tua)",
    "cal.mkt.earlyAt": "Chiude in anticipo alle {time}",
    "cal.local": "ora locale",
    "cal.country": "Paese",
    "cal.types": "Tipi di evento",
    "cal.group.central_bank": "Banche centrali",
    "cal.group.data_release": "Dati economici",
    "cal.group.markets": "Chiusure dei mercati",
    "cal.group.public_holiday": "Festività",
    "cal.badge.central_bank": "Decisione sui tassi",
    "cal.badge.data_release": "Dato economico",
    "cal.badge.market_closed": "Mercato chiuso",
    "cal.badge.early_close": "Chiusura anticipata",
    "cal.badge.public_holiday": "Festività",
    "cal.closesEarly": "chiusura anticipata",
    "cal.noTrading": "nessuna contrattazione tutto il giorno",
    "cal.released": "Pubblicato",
    "cal.seeFigure": "Vedi il dato ufficiale",
    "cal.sourceShort": "Fonte",
    "cal.news": "Notizie",
    "cal.openNote": "{exchange} aperta",
    "cal.plusMore": "+{n} altre",
    "cal.oneEvent": "1 evento",
    "cal.nEvents": "{n} eventi",
    "cal.oneHoliday": "1 festività",
    "cal.nHolidays": "{n} festività",
    "cal.nowLine": "Adesso · {time}",
    "cal.weekendClosed": "Fine settimana: borse chiuse.",
    "cal.nothingDay": "Nessun evento.",
    "cal.thisWeek": "Questa settimana",
    "cal.nextWeekLabel": "Settimana prossima",
    "cal.earlier": "Prima in settimana",
    "cal.show": "Mostra",
    "cal.tryAll": "Prova tutti i tipi di evento o disattiva «I tuoi paesi».",
    "cal.reset": "Azzera i filtri",
    "cal.prevWeek": "Settimana precedente",
    "cal.nextWeek": "Settimana successiva",
    "cal.moreWeek": "Mostra la settimana successiva",
    "cal.subscribeTitle": "Iscriviti a questo calendario",
    "cal.feedAddress": "Indirizzo del feed",
    "cal.copyLink": "Copia link",
    "cal.subFine": "Gratis, senza account. Segue i filtri che hai scelto. Notizie e contesto, non consulenza finanziaria.",
    "cal.impact": "Impatto",
    "cal.imp.high": "Alto",
    "cal.imp.medium": "Medio",
    "cal.imp.low": "Basso",
    "cal.impTip.high": "di solito muove tassi, valute e azioni",
    "cal.impTip.medium": "seguito dai mercati, li muove meno spesso",
    "cal.impTip.low": "contesto: festività, dati minori",
    "cal.impNote": "In base al tipo di evento, non è una previsione.",
    "cal.impAll": "Tutti",
    "cal.impMediumUp": "Medio +",
    "cal.impHighOnly": "Solo alto",
    "cal.nHigh": "{n} ad alto impatto",
    "cal.addShort": "Aggiungi",
};
